import { Profile } from '../../../lib/phinxapp/profiles/types';
import { publicMenu } from './publicMenu';
import { FullScreenLayout } from "../../../application/layouts";

export const publicProfile: Profile = {
  name: 'public',
  component: FullScreenLayout,
  menu: publicMenu,
};
